import { Injectable } from '@angular/core';
import { defer } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { IconCacheService } from '@finxone-platform/shared/services';
import { buildHandleBarModel } from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';

@Injectable({ providedIn: 'root' })
export class HandlebarModelService {
  // will cache the model for all consumers of this service, and clear when there are no more subscribers.
  public readonly modelCache$ = defer(() =>
    buildHandleBarModel(
      this.store,
      '',
      this.countriesCurrenciesService,
      this.iconCacheService,
      undefined,
      undefined,
      undefined,
      undefined,
      true,
    ),
  ).pipe(shareReplay({ bufferSize: 1, refCount: true }));

  constructor(
    private store: Store,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
  ) {}
}
